var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ paddingTop: _vm.safeAreaTop + 'px', paddingBottom: _vm.safeAreaBottom + 'px', minHeight: '100vh' }),attrs:{"id":"app"}},[_vm._m(0),_c('div',{staticStyle:{"position":"relative"}},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('img',{attrs:{"src":require("./assets/front-puppy/back3.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }